var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconDashboardMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 6.25C18.8789 6.25 20 7.37109 20 8.75V17.5C20 18.8789 18.8789 20 17.5 20H2.5C1.11914 20 0 18.8789 0 17.5V8.75C0 7.37109 1.11914 6.25 2.5 6.25H17.5Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M17.1875 5H2.8125C2.29492 5 1.875 4.58203 1.875 4.0625C1.875 3.54492 2.29492 3.125 2.8125 3.125H17.1875C17.707 3.125 18.125 3.54492 18.125 4.0625C18.125 4.58203 17.707 5 17.1875 5ZM15.3125 1.875H4.6875C4.16797 1.875 3.75 1.45508 3.75 0.9375C3.75 0.419922 4.16797 0 4.6875 0H15.3125C15.832 0 16.25 0.419922 16.25 0.9375C16.25 1.45508 15.832 1.875 15.3125 1.875Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDashboardMobile);
export default __webpack_public_path__ + "static/media/icon-dashboard-mobile.881c78054095309dc6b247fde754c348.svg";
export { ForwardRef as ReactComponent };